import { render, staticRenderFns } from "./TreeDetailsRow.vue?vue&type=template&id=2bd958ef"
import script from "./TreeDetailsRow.vue?vue&type=script&lang=js"
export * from "./TreeDetailsRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports